/**
 * GlassCard — 磨砂玻璃卡片 (framer-motion)
 * backdrop-filter blur + rgba 背景 + 入场 translate + opacity 动画
 */

import { motion } from 'framer-motion'

export default function GlassCard({
  children,
  delay = 0,
  riseDistance = 32,
  className = '',
  style = {},
}) {
  const classNames = 'glass-card-root' + (className ? ' ' + className : '')

  return (
    <>
      <style>{`
        .glass-card-root {
          backdrop-filter: blur(24px);
          -webkit-backdrop-filter: blur(24px);
          background: rgba(255, 255, 255, 0.08);
          border: 1px solid rgba(255, 255, 255, 0.12);
          border-radius: 1.25rem;
          padding: 1.5rem;
        }
      `}</style>

      <motion.div
        className={classNames}
        initial={{ opacity: 0, y: riseDistance }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 0.6,
          delay,
          ease: [0.22, 1, 0.36, 1],
        }}
        style={style}
      >
        {children}
      </motion.div>
    </>
  )
}
